<template>
  <div class="row">
    <div class="col-md-12" v-html="step.description" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Simpletext',
  computed: {
    ...mapGetters({
      step: 'configurator/currentStep'
    })
  }
}
</script>
